/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Studio_Image_Too_BigInputs */

const en_landing_studio_image_too_big = /** @type {(inputs: Landing_Studio_Image_Too_BigInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Images must be under 20 MB.`)
};

const zh_landing_studio_image_too_big = /** @type {(inputs: Landing_Studio_Image_Too_BigInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`图片需小于 20 MB。`)
};

/**
* | output |
* | --- |
* | "Images must be under 20 MB." |
*
* @param {Landing_Studio_Image_Too_BigInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_studio_image_too_big = /** @type {((inputs?: Landing_Studio_Image_Too_BigInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Studio_Image_Too_BigInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_studio_image_too_big(inputs)
	return zh_landing_studio_image_too_big(inputs)
});
export { landing_studio_image_too_big as "landing.studio.image_too_big" }